/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Full_Pigeon_CherishInputs */

const en_fancy_full_pigeon_cherish = /** @type {(inputs: Fancy_Full_Pigeon_CherishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Fancy_Full_Pigeon_CherishInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fancy_full_pigeon_cherish = /** @type {((inputs?: Fancy_Full_Pigeon_CherishInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Full_Pigeon_CherishInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fancy_full_pigeon_cherish(inputs)
});